import IconDangerTriangle from "@/app/(components)/generics/Icons/IconDangerTriangle";
import styles from "./ErrorMessage.module.css";

type Props = {
  message: string;
  showIcon?: boolean;
};

export default function ErrorMessage(props: Props) {
  const { message, showIcon = true } = props;

  return (
    <p className={styles.errorMessage}>
      {showIcon && <IconDangerTriangle />}
      {message}
    </p>
  );
}
